import { render, staticRenderFns } from "./DerivedMetrics.vue?vue&type=template&id=2119d872&scoped=true"
import script from "./DerivedMetrics.vue?vue&type=script&lang=js"
export * from "./DerivedMetrics.vue?vue&type=script&lang=js"
import style0 from "./DerivedMetrics.vue?vue&type=style&index=0&id=2119d872&prod&lang=scss&scoped=true"
import style1 from "./DerivedMetrics.vue?vue&type=style&index=1&id=2119d872&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2119d872",
  null
  
)

export default component.exports